import React from 'react';
import { useParams } from 'react-router-dom';
import { GroupManagementNav } from '../components/group/GroupManagementNav';
import { InsuranceVerification } from '../components/insurance/InsuranceVerification';

export const InsuranceVerificationPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">Group not found.</p>
      </div>
    );
  }

  return (
    <div>
      <GroupManagementNav groupId={id} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Insurance Verification</h1>
            <p className="mt-2 text-gray-600">
              Verify patient insurance benefits and coverage details
            </p>
          </div>

          <InsuranceVerification groupId={id} />
        </div>
      </div>
    </div>
  );
};